import React, { PureComponent } from 'react'
import NavBar from '../../../components/navBar/nav-bar';
import './inbound-detail.scss';
import storeImg from '../../../assets/img/repository/storeIcon.png';
import moment from 'moment';
import { InboundService } from '../../../service/inbound.service';
import { PageOption } from '../../../model';
import NoResult from '../../../components/no-result/no-result';
import { observable } from 'mobx';
import { observer } from 'mobx-react';
import download from '../../../assets/img/download.png';
import { Modal, List, Button, Toast } from 'antd-mobile';
import ClipboardJS from 'clipboard';

@observer
export default class InboundDetail extends PureComponent<any, any> {

  pageOption: PageOption = {
    page: 1,
    rows: 20,
    total: 0
  };

  @observable noResult: boolean = false;

  query: {start_time: string, end_time: string, goods_num: string};

  constructor(props: any) {
    super(props);
    this.state = {
      dataList: [],
      downloadVisible: false,
      currentUrl: '',
      loading: false,
      goods_order_sum: 0,
      goods_sales: 0,
      goods_total_fee: 0
    };
    this.query = {
      goods_num: this.props.match.params.goodscode,
      start_time: this.props.match.params.start_time,
      end_time: this.props.match.params.end_time
    };
    this.getList();
    const clipBoard = new ClipboardJS('.inboundInquiryBtn');
    clipBoard.on('success', () => {
      Toast.info('复制成功！');
      this.setState({
        downloadVisible: false
      })
    })
  }

  async getList() {
    if (!this.state.loading) {
      this.noResult = false;
      const data = await InboundService.getListDetail(this.pageOption, this.query);
      this.pageOption.page = data.list.current_page;
      this.pageOption.rows = +data.list.per_page;
      this.pageOption.total = +data.list.total;
      this.setState({
        dataList: [...this.state.dataList, ...data.list.data],
        goods_order_sum: data.goods_order_sum,
        goods_sales: data.goods_sales,
        goods_total_fee: data.goods_total_fee,
      });
      this.setState({
        loading: false
      });
      if (!this.state.dataList.length) {
        this.noResult = true;
      }
    }
  }

  pageSearch() {
    this.pageOption.page++;
    this.setState({
      loading: true
    });
    this.getList();
  }

  scrollLoad = ({target}: any) => {
    if (this.state.dataList.length >= this.pageOption.total) { return ; }
    if ((target.scrollHeight - target.clientHeight - target.scrollTop) < 10 ) {
      this.pageSearch();
    }
  }

  formatDate(date: any) {
    return moment(date).format('YYYY-MM-DD HH:mm:ss');
  }

  downLoad = async () => {
    Toast.loading('加载中...', 0);
    const data = await InboundService.download(this.query.start_time, this.query.end_time);
    this.setState({
      downloadVisible: true,
      currentUrl: data.url
    });
    Toast.hide();
  }

  copyUrl = () => {

  }

  inquiryList() {
    return this.state.dataList.map((item: any, index: number) => {
      return <div className="item" key={index}>
        <div className="medName">
          <img src={storeImg} alt=""></img>
          <div className="name">{item.goodsname + (item.name? `(${item.name})`: '')}</div>
        </div>
        <div className="line"></div>
        <div className="detailParams">
          <div className="param">
            <div className="paramName">单据ID</div>
            <div className="paramValue">{item.billno}</div>
          </div>
          <div className="param">
            <div className="paramName">明细序号</div>
            <div className="paramValue">{item.billsn}</div>
          </div>
          <div className="param">
            <div className="paramName">单据编号</div>
            <div className="paramValue">{item.billcode}</div>
          </div>
          <div className="param">
            <div className="paramName">日期</div>
            <div className="paramValue">{item.dates}</div>
          </div>
          <div className="param">
            <div className="paramName">时间</div>
            <div className="paramValue">{item.ontime}</div>
          </div>
          <div className="param">
            <div className="paramName">单位ID</div>
            <div className="paramValue">{item.businessid}</div>
          </div>
          <div className="param">
            <div className="paramName">单位名称</div>
            <div className="paramValue">{item.businessname}</div>
          </div>
          <div className="param">
            <div className="paramName">商品ID</div>
            <div className="paramValue">{item.goodsid}</div>
          </div>
          <div className="param">
            <div className="paramName">商品编号</div>
            <div className="paramValue">{item.goodscode}</div>
          </div>
          <div className="param">
            <div className="paramName">商品名称</div>
            <div className="paramValue">{item.goodsname}</div>
          </div>
          <div className="param">
            <div className="paramName">规格</div>
            <div className="paramValue">{item.goodsspec}</div>
          </div>
          <div className="param">
            <div className="paramName">生产厂家</div>
            <div className="paramValue">{item.manufacturer}</div>
          </div>
          <div className="param">
            <div className="paramName">产地</div>
            <div className="paramValue">{item.place}</div>
          </div>
          <div className="param">
            <div className="paramName">剂型</div>
            <div className="paramValue">{item.formula}</div>
          </div>
          <div className="param">
            <div className="paramName">数量</div>
            <div className="paramValue">{item.num}</div>
          </div>
          <div className="param">
            <div className="paramName">批号</div>
            <div className="paramValue">{item.batchcode}</div>
          </div>
          <div className="param">
            <div className="paramName">生产日期</div>
            <div className="paramValue">{item.producedate}</div>
          </div>
          <div className="param">
            <div className="paramName">有效期至</div>
            <div className="paramValue">{item.valdate}</div>
          </div>
        </div>
      </div>;
    });
  }

  render() {
    return (
      <div className="inboundDetail" onScroll={this.scrollLoad} style={{paddingTop: "0"}}>
        <div className="header">
          <NavBar title="入库查询"></NavBar>
        </div>
        <div className="inboundDetailPool">
          <div>
            <span>商品订单数</span>
            <span>{this.state.goods_order_sum}</span>
          </div>
          <div>
            <span>商品销量</span>
            <span>{this.state.goods_sales}</span>
          </div>
          <div>
            <span>商品销售总价</span>
            <span>￥{this.state.goods_total_fee}</span>
          </div>
        </div>
        <div className="inboundDetailList">
          { this.inquiryList() }
          { this.noResult && <NoResult></NoResult>}
        </div>
        <img className="downLoad" alt="download" src={download} onClick={this.downLoad}/>
        <Modal
          popup = {true}
          visible={this.state.downloadVisible}
          onClose={() => this.setState({downloadVisible: false})}
          animationType="slide-up"
        >
          <List renderHeader={() => <div className="inboundInquiryInputUrlTitle">复制下载地址</div>} className="popup-list">
            <div className="inboundInquiryInputUrl">
              <div className="tip">(请复制连接到手机自带浏览器进行下载)</div>
              <input id="inboundInquiryInputUrl" readOnly defaultValue={this.state.currentUrl} />
            </div>
            <List.Item>
              <Button type="primary" className="inboundInquiryBtn" onClick={this.copyUrl} data-clipboard-action="copy" data-clipboard-target="#inboundInquiryInputUrl">复制地址</Button>
            </List.Item>
          </List>
        </Modal>
      </div>
    )
  }
}
